import isUndefined from 'lodash/isUndefined'
import isEmpty from 'lodash/isEmpty'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  GET_TRANSACTION: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/transaction', params: payload
    })
      .then(result =>{
        return result.data
      })
    }
  },
  POST_TRANSACTION: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: "post", url: "/user/" + payload.id + "/transaction/manual", data: payload.params})
      .then(result =>{
        return result.data
      })
    }
  },
  GET_TRANSACTION_EXCEL :{
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: "get", url: "/transaction/export", params :  payload, responseType: 'blob' })
      .then(result =>{
        return result
      })
    }
  },
  PUT_TRANSACTION_MEMO: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: "put", url: "/transaction/" + payload.id, data: payload.params})
      .then(result =>{
        return result.data
      })
    }
  },
  GET_USER_TRANSACTION_EXCEL:{
    root: true,
    handler(namespacedContext, payload) {
      
      return $api({method: "post", url: "/transaction/"+payload.id+"/excel", data :  {user_language : 'ko'}, responseType: 'blob' })
      .then(result =>{
        return result
      })
    }
  },
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
